import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {isDetailsPage, NeuroMessage} from "@ignitesales/neuro-application";
import ContactFormModal from "./ContactFormModal";
import ShareActions from "./ShareActions";
import classnames from "classnames";

const ContactShareButtons = ({
    hideContactButton = false,
    hideShareButton,
    contactButtonRender,
    shareButtonRender,
    useFullWidthButtons,
    isLeftAligned,
    showContactForm: controlledShowContactForm,
    showShareActions: controlledShowShareActions,
    onControlledClose,
    onContactFormButtonClick
}) => {
    const [showContactForm, setShowContactForm] = useState(false);
    const [showShareActions, setShowShareActions] = useState(false);
    const componentClass = 'contactShareButtons';
    const classes = classnames(componentClass, {
        [`${componentClass}--fullButtons`]: useFullWidthButtons,
        [`${componentClass}--noLeftMargin`]: isLeftAligned
    });

    const onCloseContactModal = () => {
        setShowContactForm(false);
        onControlledClose && onControlledClose('contact');
    };

    const onCloseShareModal = () => {
        setShowShareActions(false);
        onControlledClose && onControlledClose('share');
    };
    const shouldShowContactButton = !hideContactButton && !isDetailsPage();

    return <div className={classes}>
        { !hideShareButton && <button className={`${componentClass}__button share-btn btn`} onClick={() => setShowShareActions(true)}>
            { !!shareButtonRender ? shareButtonRender : <><i className="ion-md-share mr-2"/><NeuroMessage id="summary.shareBtn"/></> }
        </button> }
        { shouldShowContactButton && <button className={`${componentClass}__button complete-btn btn`} onClick={() => !!onContactFormButtonClick ? onContactFormButtonClick() : setShowContactForm(true)}>
            { !!contactButtonRender ? contactButtonRender : <><i className="ion-md-checkmark-circle-outline mr-2"/><NeuroMessage id='summary.completeBtn'/></> }
        </button> }

        { shouldShowContactButton && <ContactFormModal
            isOpen={controlledShowContactForm || showContactForm}
            onClose={onCloseContactModal}
            onComplete={onCloseContactModal}
        /> }

        { !hideShareButton && <ShareActions
            isActive={controlledShowShareActions || showShareActions}
            onClose={onCloseShareModal}
        /> }
    </div>;
};

ContactShareButtons.propTypes = {
    hideContactButton: PropTypes.bool,
    hideShareButton: PropTypes.bool,
    isLeftAligned: PropTypes.bool,
    useFullWidthButtons: PropTypes.bool,
    contactButtonRender: PropTypes.node,
    shareButtonRender: PropTypes.node,
    showContactForm: PropTypes.bool,
    showShareActions: PropTypes.bool,
    onControlledClose: PropTypes.func,
    onContactFormButtonClick: PropTypes.func
};

export default ContactShareButtons;
